import { gql } from 'graphql-tag';
import { INTERNAL_LINKS_FRAGMENT } from './internalLinks.fragment';

export const SEO_FRAGMENT = gql`
    ${INTERNAL_LINKS_FRAGMENT}

    fragment SEO_FRAGMENT on SeoResults {
        redirection {
            code
            uri
        }
        info {
            canonicalUri
            areaName
            areaExpansions {
                level
                name
                url
            }
        }
        onPage {
            description
            title
            robots
            heading
        }
        breadcrumbs {
            label
            tracking
            uri
            i18nLabelKey
            noAppend
        }
        internalLinks {
            currentlyAvailable {
                ...INTERNAL_LINKS_FRAGMENT
            }
            townsAndCities {
                ...INTERNAL_LINKS_FRAGMENT
            }
        }
    }
`;
